<template>
  <el-dialog
      custom-class="!rounded-none flex flex-col justify-center items-center"
      :visible="true"
      :fullscreen="true"
      :center="true"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
    <span slot="title" class="hidden"></span>

    <div class="w-full md:w-96 m-auto opacity-0 animate-fadeIn">
      <el-form
          ref="introFormRef"
          :model="introForm"
          :rules="formRules">
        <h2 class="mb-2">Success!
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#9eb74a" viewBox="0 -960 960 960"
               class="ml-1 inline-block">
            <path
                d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z"/>
          </svg>
          <br> Welcome to Onvocado.
        </h2>
        <p class="mb-4">We'd love to learn a bit about you and your business so we can make your experience even
          better.</p>
        <div class="opacity-0 animate-fadeIn-slow">
          <el-form-item
              class="basic"
              :class="$style.formItem"
              prop="companyName"
              label="What's your business name?">
            <el-input
                v-model="introForm.companyName"
                maxlength="150"
                type="text"
                name="Business Name"
                placeholder="Company"></el-input>
          </el-form-item>
          <el-form-item
              class="basic"
              :class="$style.formItem"
              prop="domain"
              label="What's your website URL?">
            <el-input
                v-model="introForm.domain"
                type="text"
                name="Domain Name"
                placeholder="www.business.com"></el-input>
          </el-form-item>

          <el-form-item class="mt-6">
            <button ref="registrationBtn"
                    class="w-full btn primary"
                    type="button"
                    :disabled="submitting"
                    @click="formSubmit">Get Started
            </button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!--    <span slot="footer" class="mb-12 dialog-footer">-->
    <!--      <el-button type="primary" size="medium" @click="submit" :loading="submitting">Continue</el-button>-->
    <!--    </span>-->
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import validationMixin from '@components/mixins/validation'

export default {
  name: 'IntroSurveyModal',
  mixins: [validationMixin],
  data() {
    return {
      introForm: {
        companyName: '',
        domain: '',
      },
      formRules: {
        companyName: [
          { required: true, message: 'Please enter your company name.', trigger: 'blur' },
          { min: 2, max: 150, message: 'Company name must be between 2 and 150 characters.', trigger: 'blur' },
        ],
        domain: [
          { required: true, message: 'Please enter your website URL.', trigger: 'blur' },
          { validator: this.validateDomainURL, trigger: 'blur' },
        ],
      },
      submitting: false,
    }
  },
  methods: {
    ...mapActions('users', ['completeIntroSurvey']),
    validateDomainURL(rule, value, callback) {
      if (!value) callback()

      const urlWithProtocol = this.setHttp(value.trim()) // Ensure HTTP protocol is set
      if (!this.validURL(urlWithProtocol)) {
        callback(new Error('Please enter a valid website URL'))
      } else {
        callback()  // Validation passed
      }
    },
    formSubmit() {
      this.$refs.introFormRef.validate((valid) => {
        if (valid) {
          this.submitting = true
          this.completeIntroSurvey(this.introForm)
              .then(() => {
                this.$message.success('You\'re all set. 🚀 Let’s start creating!')
                this.$emit('close')
              })
              .catch((error) => {
                this.$message.error(error || 'An error occurred while submitting the form.')
              })
              .finally(() => {
                this.submitting = false
              })
        } else {
          this.$message.error('Please correct the errors in the form.')
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" module>
.formItem {
  label {
    &::before {
      content: '' !important;
    }
  }
}
</style>